import React, { useMemo } from "react";
import { PropertyForm } from "../../common";
import { Grid } from "@material-ui/core";

const LoginFormDesigner = ({ setDesignProps }) => {
  const pform = useMemo(
    () => ({
      section: {
        padding: 1,
        paddingBottom: 2
      },
      header: {
        paddingBottom: 1
      },
      field: {
        paddingBottom: 1
      },
      hideCancel: true,
      hideReset: true,
      hideSave: true,
      sections: [
        {
          title: "Login as:",
          layout: ["loginTestuser"]
        }
      ],
      fieldInfo: {
        loginTestuser: {
          label: "User",
          editor: "button",
          onClick: () => {
            setDesignProps({
              isInitialValid: true,
              initValues: {
                username: "testuser@lenderclose.com",
                password: "password",
                remember: false
              }
            });
          }
        }
      }
    }),
    [setDesignProps]
  );

  return (
    <Grid container>
      <Grid item xs={12}>
        <PropertyForm {...pform} />
      </Grid>
    </Grid>
  );
};

export default LoginFormDesigner;
